/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React, { Component } from "react";
import { ConnectedRouter } from "connected-react-router";
import jwt_decode from "jwt-decode";
import { Provider } from "react-redux";
import { connect } from "react-redux";
import clsx from "clsx";

import { store, history } from "./store";
import { Auth } from "./api/agent";
import { logout, logoutMalformed } from "./actions/auth/authAction";
import { LOGOUT_REQUEST } from "./actions/auth/authActionTypes";
import { SET_CURRENT_USER } from "./actions/auth/authActionTypes";
import LoadingIndicator from "./shared/components/LoadingIndicator";
import LogRocket from "logrocket";

import Router from "./Router";
import ScrollToTop from "./ScrollToTop";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "@zoomus/websdk/dist/css/react-select.css";

import "./App.scss";
import "./assets/base.scss";

import AssetLookupModal from "./pages/Dashboard/DashboardAssets/AssetLookup/AssetLookupModal";

import { hideAddAssetsModal } from "./actions/asset/addAssetsModalAction";

const validateToken = async (self, token) => {
  let resp = await Auth.validateToken();

  if (resp.success === true) {
    localStorage.setItem("token", resp.user.token);
    const decoded = jwt_decode(resp.user.token);
    store.dispatch({
      type: SET_CURRENT_USER,
      payload: {
        token: resp.user.token,
        picture: decoded.picture,
        fullName: decoded.fullName,
        email: decoded.email,
        id: decoded.id,
        isPartner: decoded.isPartner,
        partnerStatus: decoded.partnerStatus,
        partnerSlug: decoded.partnerSlug,
        partnerName: decoded.partnerName,
      },
    });

    if (process.env.REACT_APP_CUSTOMERLY_KEY) {
      window.customerlySettings = {
        app_id: process.env.REACT_APP_CUSTOMERLY_KEY,
        user_id: decoded.id,
        name: decoded.fullName,
        email: decoded.email,
      };
      window.heap.identify(decoded.id);
      window.heap.addUserProperties({
        Name: decoded.fullName,
        email: decoded.email,
      });
    }

    if (process.env.REACT_APP_LOGROCKET_KEY) {
      LogRocket.identify(process.env.REACT_APP_LOGROCKET_KEY, {
        name: decoded.fullName,
        email: decoded.email,
      });
    }

    self.setState({
      loading: false,
    });
    return resp;
  } else {
    store.dispatch({
      type: SET_CURRENT_USER,
      payload: {},
    });
    return false;
  }
};

class App extends Component {
  constructor(props) {
    super();
    this.state = {
      loading: true,
      loaded: false,
    };
  }

  async componentDidMount() {
    const token = localStorage.getItem("token");
    if (token) {
      var decoded = null;
      try {
        decoded = jwt_decode(token);
      } catch (e) {
        logoutMalformed();
        store.dispatch({
          type: LOGOUT_REQUEST,
        });
        window.location = "/login";
      }
      const currentTime = Date.now() / 1000;
      if (decoded && decoded.exp < currentTime) {
        logoutMalformed();
        store.dispatch({
          type: LOGOUT_REQUEST,
        });
        window.location = "/login";
      } else {
        try {
          var yes = await validateToken(this, token);
          if (!yes) {
            this.props.logoutUser();
            this.setState({ loading: false });
            history.push("/login");
          }
        } catch (err) {
          this.props.logout();
          this.setState({ loading: false });
          history.push("/login");
        }
      }
    } else this.setState({ loading: false });
  }

  render() {
    const { loading } = this.state;
    const { assetsAddModal, hideAddAssetsModal } = this.props;
    const { show } = assetsAddModal;
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <ScrollToTop>
            {loading ? (
              <LoadingIndicator loading={loading} />
            ) : (
              <div
                className={clsx("app-wrapper", {
                  "app-sidebar-mobile-open": this.props.sidebar.show,
                })}
              >
                <AssetLookupModal
                  modalOpen={show}
                  toggleModal={hideAddAssetsModal}
                />
                <ToastContainer />
                <Router />
              </div>
            )}
          </ScrollToTop>
        </ConnectedRouter>
      </Provider>
    );
  }
}
const mapStateToProps = (state) => ({
  sidebar: state.sidebar,
  auth: state.login,
  assetsAddModal: state.assetsAddModal,
});
const mapDispatchToProps = (dispatch) => ({
  logout: () => {
    logout(dispatch);
  },
  hideAddAssetsModal: () => hideAddAssetsModal(dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(App);
